//FOR HANDLE BOTH FOMIK AND STATE MANAGEMENT FOR YEAR SELECTION

// import { useState } from "react";
// import CustomSelectDropdown from "../custom_components/CustomSelectDropdown/CustomSelectDropdown";


// const CustomYearSelector = ({ initialYear, formik }) => {
//     const currentYear = new Date().getFullYear();
//     const startYear = Math.min(initialYear, currentYear);
//     const endYear = currentYear + 2;

//     const years = Array.from(
//         { length: endYear - startYear + 1 },
//         (_, i) => String(startYear + i)
//     );

//     const selectedYear = formik.values.year;

//     const handleChange = (selectedOption) => {
//         formik.setFieldValue('year', selectedOption?.value || currentYear);
//     };


//     return (
//         <div>
//             {/* <label style={{ marginRight: '10px' }}>Select Year:</label> */}
//             <CustomSelectDropdown
//                 name="year"
//                 placeholder="Select Year"
//                 options={years.map((yr) => ({
//                     label: yr === String(currentYear) ? `${yr}` : yr,
//                     value: yr,
//                 }))}
//                 value={
//                     selectedYear
//                         ? {
//                             label:
//                                 selectedYear === String(currentYear)
//                                     ? `${selectedYear}`
//                                     : selectedYear,
//                             value: selectedYear,
//                         }
//                         : null
//                 }
//                 onChange={handleChange}
//                 isMulti={false}
//                 isClearable={false}
//                 width="200px"
//             />
//         </div>
//     );
// };

// export default CustomYearSelector;



import CustomSelectDropdown from "../custom_components/CustomSelectDropdown/CustomSelectDropdown";

const CustomYearSelector = ({ initialYear = new Date().getFullYear(), formik, value, onChange }) => {
    const currentYear = new Date().getFullYear();
    const startYear = Math.min(initialYear, currentYear);
    const endYear = currentYear + 2;

    const years = Array.from(
        { length: endYear - startYear + 1 },
        (_, i) => String(startYear + i)
    );

    // Determine selected value from either formik or props
    const selectedYear = formik ? formik.values.year : value;

    const handleChange = (selectedOption) => {
        const newValue = selectedOption?.value || currentYear;

        if (formik) {
            formik.setFieldValue("year", newValue);
        } else if (onChange) {
            onChange(newValue);
        }
    };
    return (
        <CustomSelectDropdown
            name="year"
            placeholder="Select Year"
            options={years?.map((yr) => ({
                label: yr,
                value: yr,
            }))}
            value={
                selectedYear
                    ? {
                          label: selectedYear,
                          value: selectedYear,
                      }
                    : null
            }
            onChange={handleChange}
            isMulti={false}
            isClearable={false}
            width="200px"
        />
    );
};

export default CustomYearSelector;
